import { FaroButton, FaroText, FontWeights, grey } from "@faro-lotv/flat-ui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Stack } from "@mui/material";
import { memo, type JSX } from "react";

type AiNavigationCardProps = {
  /** Current annotation index (0-based) */
  currentIndex: number;
  /** Total number of annotations */
  total: number;
  /** Whether previous navigation is available */
  canNavigatePrevious: boolean;
  /** Whether next navigation is available */
  canNavigateNext: boolean;
  /** Callback when previous button is clicked */
  onPrevious(): void;
  /** Callback when next button is clicked */
  onNext(): void;
};

/** @returns navigation card with previous/next controls */
export const AiNavigationCard = memo(function AiNavigationCard({
  currentIndex,
  total,
  canNavigatePrevious,
  canNavigateNext,
  onPrevious,
  onNext,
}: AiNavigationCardProps): JSX.Element {
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <FaroButton
        variant="secondary"
        onClick={onPrevious}
        disabled={!canNavigatePrevious}
        aria-label="Previous annotation"
        size="s"
        sx={{
          color: grey[600],
          minWidth: "auto",
          width: "fit-content",
          borderColor: grey[200],
          "&:disabled": {
            color: grey[400],
            borderColor: grey[200],
            backgroundColor: grey[50],
          },
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 20 }} />
      </FaroButton>

      <FaroText variant="heading14" fontWeight={FontWeights.SemiBold}>
        {currentIndex + 1} of {total}
      </FaroText>

      <FaroButton
        variant="secondary"
        onClick={onNext}
        disabled={!canNavigateNext}
        aria-label="Next annotation"
        size="s"
        sx={{
          color: grey[600],
          minWidth: "auto",
          width: "fit-content",
          borderColor: grey[200],
          "&:disabled": {
            color: grey[400],
            borderColor: grey[200],
            backgroundColor: grey[50],
          },
        }}
      >
        <ArrowForwardIcon sx={{ fontSize: 20 }} />
      </FaroButton>
    </Stack>
  );
});
